const messages = {
    sk: {
        general: {
            loading: 'Načítava sa...',

            // Stránky prihlásenia a registrácie
            dont_have_account: 'Nemáte vytvorený účet',
            already_have_account: 'Už máte vytvorený účet',

            // Stránka prehľadu
            no_announcements: 'Momentálne nemáte žiadne oznámenia.',
            no_selected_lecturer: 'Lektor zatiaľ nebol zvolený.',
            have_unassigned_roles: 'Máte {unassignedRoles} novú žiadosť pre priradenie role. | Máte {unassignedRoles} nových žiadostí pre priradenie rolí.',
            no_role_assigned: 'Momentálne nemáte priradenú žiadnu rolu.',
            ready_player_count: 'Počet pripravených hráčov',
            assigned_divisions: 'Priradené divízie',
            your_team: 'Váš tím',

            // Stránka hier
            all_divisions: 'Všetky divízie',
            team_count: 'Počet tímov',
            legend: 'Legenda',
            drop_here: 'Položte sem',
            status: 'Stav',
            waiting_for_players: 'Čakám na hráčov',

            template: 'Šablona',
            situation: 'Modelová situácia',
            players: 'Hráči',

            total_division_cost: 'Celkové náklady divízie',
            current_round: 'Aktuálne kolo',
            round_time: 'Dĺžka kola',
            selected_employee_requirements: 'Zvolené požiadavky na zamestnanca',
            range: 'Rozsah',
            rounds: 'Kolá',
            error: 'Chyba',
            required: 'povinné',
            warning: 'Upozornenie',
            
            game_finished_alert: "Aktuálna hra bola ukončená",
            game_canceled_alert: "Hra bola zrušená a v jej priebehu ďalej nie je možné pokračovať.",
        },

        titles: {
            // Stránky prihlásenia a registrácie
            login: 'Prihlásenie',
            register: 'Registrácia',

            // Stránka prehľadu
            dashboard: 'Prehľad',
            announcements: 'Oznámenia',
            current_lecturer: 'Aktuálne zvolený lektor',
            game_invitation: 'Pozvánka do hry',
            game_status: 'Aktuálne vytvorená hra',
            change_lecturer: 'Zmena lektora',

            // Stránka používateľov
            user_list: 'Zoznam používateľov',
            creating_user: 'Vytvorenie nového používateľa',
            editing_user: 'Editácia používateľa',

            // Stránka dokumentov
            document_list: 'Zoznam dokumentov',
            creating_document: 'Vytvorenie nového dokumentu',
            editing_document: 'Editácia dokumentu',

            // Stránka modelových situácií
            situation_list: 'Zoznam modelových situácií',
            creating_situation: 'Vytvorenie novej modelovej situácie',
            editing_situation: 'Editácia modelovej situácie',

            // Stránka hier
            lecturer_game_list: 'Zoznam vašich hier',
            creating_game: 'Vytvorenie novej hry',
            team_settings: 'Nastavenie tímov',
            choosing_users: 'Výber hráčov',
            add_new_team: 'Pridať nový tím',
            game_successfully_created: 'Hra bola úspešne vytvorená',
            round_results_dialog_long: 'Vyhodnotenie výsledkov kola',
            round_results_dialog_short: 'Vyhodnotenie výsledkov',
            end_round: 'Koniec kola',
            save_decision: 'Finálne uloženie rozhodnutia',
            end_game_lecturer: 'Koniec hry',
            end_game_player: 'Oznámenie o konci hry',

            // Všeobecné
            parameter_settings: 'Nastavenie parametrov',
            editing_profile: 'Editácia profilu',
        },

        labels: {
            first_name: 'Meno',
            last_name: 'Priezvisko',
            email: 'Email',
            role: 'Rola',
            password: 'Heslo',
            password_confirm: 'Heslo (znovu)',
            remember_me: 'Zapamätať si ma',

            name: 'Názov',
            document_type: 'Typ dokumentu',
            document_subtype: 'Podtyp dokumentu',
            content: 'Obsah',

            select_role: 'Vyberte rolu',
            page: 'Vyberte stránku',
            text: 'Zadajte text',
            video: 'Vyberte video (voliteľné)',
            language: 'Vyberte jazyk',

            // Stránka modelových situácií
            situation_name: 'Názov modelovej situácie',
            template: 'Šablona',
            document: 'Dokument',

            // Stránka hier
            situation: 'Modelová situácia',
        },

        buttons: {
            // Stránky prihlasenia a registrácie
            login: 'Prihlasiť',
            logging_in: 'Prihlasujem...',
            register: 'Registrovať',
            registering: 'Registrujem...',

            // Stránka používateľov
            create_user: 'Vytvoriť nového používateľa',

            // Stránka dokumentov
            create_document: 'Vytvoriť nový dokument',

            // Stránka modelových situácií
            create_situation: 'Vytvoriť novú modelovú situáciu',

            // Stránka hier
            create_game: 'Vytvoriť novú hru',
            random_split: 'Náhodne rozdeliť',
            random_split_info: 'Náhodné rozdeľovanie do tímov funguje len pre 4 a viac online hráčov.',
            start_game: 'Spustiť hru',
            cancel_game: 'Zrušiť hru',
            start_next_round: 'Spustiť ďalšie kolo',
            end_game: 'Ukončiť hru',

            // Stránka editácie profilu
            upload: 'Nahrať',
            remove: 'Zmazať',

            // Navigácia
            edit_profile: 'Upraviť profil',
            logout: 'Odhlasiť sa',

            // Všeobecné
            accept: 'Potvrdiť',
            cancel: 'Zrušiť',
            enter_to_game: 'Vstupiť do hry',
            confirm: 'Potvrdiť',
            save: 'Uložiť',
            saving: 'Ukladám...',
            save_and_finish: 'Uložiť a ukončiť',
            assign: 'Priradiť',
            back: 'Späť',
            close: 'Zavrieť',
            evaluate_round: 'Vyhodnotiť kolo',
            evaluating_round: 'Vyhodnocujem...',
            confirm_endgame_lecturer: 'Potvrdiť koniec hry',
            confirm_endgame_player: 'Vrátiť sa na hlavnú stránku',

            company: 'Informácie o podniku',
            situation: 'Modelová situácia'
        },

        links: {
            // Stránky prihlasenia a registrácie
            register: 'Zaregistrujte sa',
            login: 'Prihlasiť sa',
            forgot_password: 'Zabudli ste heslo',

            // Stránka prehľadu
            change_lecturer: 'Zmeniť lektora',
            back_to_dashboard: 'Návrat na prehľad',
            return_to_dashboard: 'Vrátiť sa na prehľad',

            // Navigácia
            dashboard: 'Prehľad',
            users: 'Používatelia',
            documents: 'Dokumenty',
            situations: 'Modelové situácie',
            games: 'Hry lektora'
        },
        
        pages: {
            dashboard: "Prehľad",
            profile: "Profil",
            users: {
                index: "Používatelia",
                create: "Vytvoriť používateľa",
                edit: "Upraviť používateľa",
            },
            documents: {
                index: "Dokumenty",
                create: "Vytvoriť dokument",
                edit: "Upraviť dokument",
                preview: "Dokument",
            },
            situations: {
                index: "Modelové situácie",
                create: "Vytvoriť modelovú situáciu",
                edit: "Upraviť modelovú situáciu",
            },
            games: {
                play: "Hra",
                index: "Hry lektora",
                create: "Vytvoriť hru",
            },
            change: {
                lecturer: "Zmeniť lektora",
            }
        },

        placeholders: {
            search: 'Vyhľadať...',
            role: 'Vyberte rolu...',
            name_of_page: 'Vyberte stránku...',
            document_type: 'Vyberte typ dokumentu...',
            document_subtype: 'Vyberte podtyp dokumentu...',
            template: 'Vyberte šablonu...',
            document: 'Vyberte dokument...',
            situation: 'Vyberte modelovú situáciu...',
            language: 'Vyberte jazyk...',
            type_message: 'Napíšte správu...',
            empty_list: 'Zoznam je prázdny...',
        },

        tableColumns: {
            //  Stránka používateľov
            user_name: 'Meno používateľa',
            email: 'Email',
            role: 'Rola',

            // Stránka dokumentov
            document_name: 'Názov dokumentu',
            document_type: 'Typ dokumentu',

            // Stránka modelových situácií
            situation_name: 'Názov modelovej situácie',
            template: 'Šablona',
            document: 'Dokument',

            // Stránka hier
            situation: 'Modelová situácia',
            rounds: 'Počet kôl',
            round_length: 'Dĺžka kola',
            created_at: 'Vytvorená',
            state: 'Aktuálny stav',

            // Všeobecné
            actions: 'Akcie',
            team: 'Tím',

            // Divízia financií
            loan_amount: 'Výška pôžičky',
            loan_payment: 'Platba za pôžičku',

            // Divízia HR
            hourly_operator_wage: 'Hodinová mzda operátora',
            hourly_quality_wage: 'Hodinová mzda kvalitára',
            hourly_maintenance_wage: 'Hodinová mzda údržbára',
            afternoon_hourly_bonus: 'Príplatok za poobednú zmenu',
            night_hourly_bonus: 'Príplatok za nočnú zmenu',
            weekend_bonus: 'Príplatok za víkendový deň',
            holiday_bonus: 'Príplatok za sviatkový deň',
            employee_entry_training: 'Vstupný tréning zamestnanca',
            recruitment_cost: 'Cena za nábor',
            average_fluctuation_cost: 'Priemerné náklady za fluktuáciu',
            non_production_day: 'Neprodukčný deň (priemerné náklady)',

            // Divízia nákupu
            model: 'Model',
            modification_line_cost: 'Cena za modifikáciu linky + licencia',
            sell_price: 'Cena predaja',
            annual_estimated_demand: 'Odhadovaný ročný dopyt',
            price_with_weight: 'Cena s váhou',
            suppliers: 'Dodávatelia',
            discount_every_next_model: 'Zľava za každý ďalší model',
            van_price: 'Cena za dodávku',
            lorry_price: 'Cena za nákladné auto',
            truck_price: 'Cena za kamion',
            average_capacity: 'Priemerná kapacita',
            default_transport: 'Pôvodný druh prepravy',
            estimated_demands_for_individual_rounds: 'Odhadované dopyty za jednotlivé kolá',
            round: 'Kolo',
            product: 'Produkt',
            supplier: 'Dodávateľ',
            transport: 'Preprava',
            material: 'Materiál',
            prod_plan: 'Výrobný plán',

            // Divízia výroby
            production_operations: 'Počet výrobných operácií',
            min_operation_time: 'Minimálny čas na operáciu',
            max_prod_capacity: 'Maximálna výrobná kapacita',
            line_diversity: 'Diverzita liniek',
            average_absence: 'Priemerná absencia',
            line_speed: 'Rýchlosť linky',
            shift_length: 'Dĺžka zmeny',
            maintenance_type: 'Typ údržby',
            maintenance: 'Údržba',
            cost: 'Náklady',
            quality: 'Kvalita',
            correction: 'Oprava',

            // Všeobecné
            shift: 'Zmena',
            prod_operators: 'Operátori',
            quality_employees: 'Kvalitári',
            handymen: 'Údržbári',
            working_days: 'Pracovné dni',
            weekend_days: 'Víkendové dni',
            holidays: 'Sviatky',
            count: 'Počet',
            statistic: 'Štatistický znak',
            value: 'Hodnota',

            prod_time: 'čas výroby',
            idle_time: 'prestoj',
            sportage: 'sportage',
            ceed: 'ceed',
            optima: 'optima',
            rio: 'rio',
            esoul: 'esoul',
            
            gameResults: {
                ranking: "Poradie",
                team: "Tím",
                score: "Výsledok",
            }
        },

        tabs: {
            team_comparison: 'Porovnanie tímov',
        },

        defaultMessages: {
            no_users_loaded: 'Neboli načítaní žiadni používatelia.',
            no_documents_loaded: 'Neboli načítané žiadne dokumenty.',
            no_situations_loaded: 'Neboli načítané žiadne modelové situácie.',
            no_parameters_loaded: 'Neboli načítané žiadne parametre.',
            no_games_loaded: 'Neboli načítane žiadne hry.',
            document_not_found: 'Nenašiel sa dokument k tejto pracovnej pozícií.',
            end_round_message: 'Skontrolujte si svoje rozhodnutia, o chvíľu vyprší čas pre kolo.',
            wait_for_other_teams: 'Počkajte, kým svoju prácu dokončia ostatné tímy...',
            wait_for_evaluation: 'Počkajte na vyhodnotenie kola...',
            round_has_ended: 'Aktuálne kolo bolo skončené.',
        },

        helpTexts: {
            do_not_fill_template: 'Pre všeobecné dokumenty nevyplňajte šablonu.',
            no_subtypes_for_selected_options: 'Pre zvolenú šablonu a typ dokumentu neexistujú žiadne podtypy.',
        },

        options: {
            // Stránka používateľov
            without_roles: 'Bez role',
            stopped: 'Zastavená'
        },

        gameParameters: {
            operation_time: 'Čas na realizáciu 1 operácie',
            max_prod_capacity: 'Maximálna výrobná kapacita',
            entry_budget: 'Vstupný rozpočet',
            recruitment_cost: 'Náklady na nábor zamestnanca',
            average_absence: 'Priemerná absencia',
            break: 'Prestávka (po 6 hod.)',
            employee_entry_training: 'Vstupné školenie zamestnanec',
            monthly_storing_car_costs: 'Mesačné náklady na skladovanie auta/kolo',
            monthly_storing_material_costs: 'Mesačné náklady na skladovanie materiálu/kolo',
            non_production_day: 'Deň neprodukcie (priemerné mzdové náklady)',
            night_hourly_bonus: 'Hodinový príplatok za nočnú prácu',
            afternoon_hourly_bonus: 'Hodinový príplatok za poobednú prácu',
            weekend_bonus: 'Príplatok za prácu cez víkend',
            holiday_bonus: 'Príplatok za prácu cez sviatok',
            working_days: 'Počet pracovných dní',
            weekend_days: 'Počet víkendových dní',
            holidays: 'Počet sviatkov',
            round_length: 'Dĺžka kola',
            round_count: 'Počet kôl',
            monthly_storing_car_cost: 'Mesačný poplatok za skladovanie auta',
            monthly_storing_material_cost: 'Mesačný poplatok za skladovanie materiálu',
            min_operation_time: 'Minimálny čas operácie',
            production_process_cost: 'Náklady výrobného procesu'
        },

        situationParameters: {
            hourly_operator_wage: 'Hodinová mdza operátora',
            hourly_quality_wage: 'Hodinová mzda zamestnanca kvality',
            hourly_maintenance_wage: 'Hodinová mzda údržbára',
            line_diversity: 'Diverzita liniek',
            production_operations: 'Počet výrobných operácií',
            estimated_demand: 'Odhadovaný dopyt',
            product_price: 'Cena produktu',
            account_balance: 'Stav na účte',
            average_fluctuation_rate: 'Priemerná miera flaktuácie',
            capacity_truck: 'Kapacita kamióna',
            capacity_lorry: 'Kapacita nákladného auta',
            capacity_van: 'Kapacita dodávky'
        },

        playerParameters: {
            hr_budget: 'Rozpočet HR/kolo',
            purchase_budget: 'Rozpočet nákupu/kolo',
            production_budget: 'Rozpočet výroby/kolo',
            estimated_hr_costs: 'Odhad nákladov HR',
            estimated_purchase_costs: 'Odhad nákladov nákupu',
            estimated_production_costs: 'Odhad nákladov výroby',
            estimated_revenue: 'Odhad výnosov',
            loan_amount: 'Výška pôžičky',
            estimated_recruitment_costs: 'Odhadované náklady na nábor',
            estimated_wage_costs: 'Odhadované náklady na mzdy',
            estimated_recruitment_cost: 'Odhadované náklady na nábor',
            estimated_wage_cost: 'Odhadované náklady na mzdy'
        },

        notifications: {
            // Stránka používateľov
            user_successfully_created: 'Používateľ <b>{userName}</b> bol úspešne vytvorený.',
            user_successfully_edited: 'Používateľ <b>{userName}</b> bol úspešne upravený.',
            user_successfully_deleted: 'Používateľ <b>{userName}</b> bol úspešne vymazaný.',

            // Stránka dokumentov
            document_successfully_created: 'Dokument <b>{documentName}</b> bol úspešne vytvorený.',
            document_successfully_edited: 'Dokument <b>{documentName}</b> bol úspešne upravený.',
            document_successfully_deleted: 'Dokument <b>{documentName}</b> bol úspešne vymazaný.',

            // Stránka modelových situácií
            situation_successfully_created: 'Modelová situácia <b>{situationName}</b> bola úspešne vytvorená.',
            situation_successfully_edited: 'Modelová situácia <b>{situationName}</b> bola úspešne upravená.',
            situation_successfully_deleted: 'Modelová situácia <b>{situationName}</b> bola úspešne vymazaná.',

            // Stránka editácie profilu
            profile_successfully_edited: 'Váš profil bol úspešne upravený.',

            //Stránka editácie pomocníka
            help_successfully_edited: 'Pomocník bol úspešne upravený.',
            help_not_edited: 'Pomocník nebol upravený.',
            
            game_successfully_created: 'Hra s modelovou situáciou bola úspešne vytvorená.',
            
            lecturer_successfully_changed: 'Úspešne ste si zmenili lektora. Váš aktuálny lektor je <b>{lecturerName}</b>.',
        },



        sections: {
            general_information: 'Všeobecné informácie',
            entering_decision: 'Zadávanie rozhodnutí',
            other_divisions_input: 'Vstupy z iných divizií',
            previous_round_results: 'Informácie z minulého kola',
        },

        accordions: {
            model_table: 'Tabuľka modelov',
            supplier_table_material_prices: 'Tabuľka dodávateľov - ceny materiálov',
            supplier_table_transport_prices: 'Tabuľka dodávateľov - ceny preprepráv',
            estimated_demand_table: 'Tabuľka odhadovaných dopytov',
            general_information: 'Všeobecné informácie',
            line_table_and_shift_table: 'Tabuľky liniek a zmien',
            maintenance_table: 'Tabuľka údržby',
            quality_table: 'Tabuľka kvality'
        },

        otherInputs: {
            allocated_budget_division_finance: 'Pridelený rozpočet (divízia financií)',
            employee_table_division_production: 'Tabuľka zamestnancov (divízia výroby)',
            material_in_production_division_purchase: 'Dostupný materiál (divízia nákupu)'
        },

        parameters: {
            // Divízia financií
            entry_budget: 'Vstupný rozpočet',

            // Divízia nákupu
            monthly_storing_car_cost: 'Mesačné náklady na skladovanie auta',
            monthly_storing_material_cost: 'Mesačné náklady na skladovanie materiálu',
        },

        skills: {
            manual_skill: 'manuálna zručnosť',
            car_construction_knowledge: 'znalost konštrukcie a funkčnosti automobilu',
            innovative_thinking: 'inovatívne myslenie ',
            working_in_diverse_collective: 'schopnosť pracovať v rôznorodom kolektíve',
            focus_on_quality: 'zameranie na kvalitu',
            computer_skills: 'znalosť práce s počítačom',
            electrical_engineering_decree_21: 'vyhlaska elektrotechnika §21',
            presentation_skills: 'prezentačné zručnosti',
            developed_fine_motor_skills: 'rozvinutá jemná motorika',
            driving_licence_B_experienced: 'vodičské oprávnenie sk. B - skúsený vodič',
            willingness_to_work_in_tact: 'ochota pracovať v takte',
            open_to_new_challenges: 'ambiciózny, otvorený novým výzvam',
            ability_to_perform_stereo_type_work: 'schopnosť vykonávať stereotypný typ práce',
            analytical_and_technical_thinking: 'analytické a technické myslenie',
            valid_forklift_licence: 'platná licencia VZV',
            sense_for_details: 'zmysel pre detail, precíznosť',
            ability_to_respond_promptly: 'schopnosť pohotovo reagovať ',
            english_on_communication_level: 'úroveň anglického jazyka na hovorovej úrovni',
            developed_perception_by_touch_or_sight: 'rozvinuté vnímanie prostred.hmatu/zraku'
        },

        dataTable: {
            all: 'Všetky',
            show: 'Zobraziť',
        },

        dialogs: {
            upload_image_title: 'Nahratie profilového obrázku',
            drop_file_here: 'Položte tu súbor',
            employee_dialog_title: 'Výber požadovaných zručnosti',
            employee: 'Zamestnanec',
            selected_skills: 'Počet zvolených zručností',
            job_description: 'Popis pracovnej pozície',
            confirm_dialog_save_decision_text: 'Ste si istý, že chcete spraviť finálne uloženie svojho rozhodnutia.<br />V prípade, ak nevyplníte povinné polia bude celý tím diskvalifikovaný!',
            endgame_dialog_lecturer_text: 'Chcete ukončiť hru?',
            endgame_dialog_player_text: 'Hra bola ukončená.',
            end_game_modal: {
                titles: {
                    game_finished: 'Aktuálna hra bola ukončená!',
                    game_canceled: 'Aktuálna hra bola zrušená!',
                }
            },
            confirm_game_cancelation: 'Naozaj si želáte zrušiť danú hru?',
            round_results_team_disqualified: 'Tím bol diskvalifikovaný.',
            round_results_empty: 'Neexistujú žiadne výsledky.',
            round_results_interim_results: 'Priebežné výsledky',
            round_results_overall_results: 'Celkové výsledky',
            help: {
                title: "Pomocník",
                empty_text: "Pomocník pre túto stránku neexistuje."
            },
            edit_help: {
                title: "Upraviť pomocníka"
            }
        },

        divisions: {
            finance_division: 'Divízia financií',
            hr_division: 'Divízia HR',
            purchase_division: 'Divízia nákupu',
            production_division: 'Divízia výroby'
        },

        actions: {
            edit: 'Editovať',
            remove: 'Vymazať'
        },

        roles: {
            no_role: 'Bez role',
            admin: 'Administrátor',
            lecturer: 'Lektor',
            player: 'Hráč'
        },
        
        languages: {
            SK: "Slovenský",
            EN: "Anglický"
        },

        states: {
            created: 'Vytvorená',
            started: 'Spustená',
            canceled: 'Zrušená',
            finished: 'Dokončená'
        },

        documentTypes: {
            manual: 'Manuál',
            situation: 'Modelová situácia',
            company: 'Spoločnosť',
            employee: 'Zamestnanec'
        },

        documentSubTypes: {
            production_operator: 'Operátor výroby',
            quality_employee: 'Zamestnanec kvality',
            handyman: 'Udržbár'
        },

        templates: {
            managing_automotive: 'Manažment automobilového priemyslu'
        },

        transports: {
            van: 'Dodávka',
            lorry: 'Nakladné auto',
            truck: 'Kamión'
        },

        models: {
            sportage: 'Sportage',
            ceed: 'Ceed',
            optima: 'Optima hybrid',
            rio: 'Rio',
            esoul: 'eSoul'
        },

        employees: {
            production_operator: 'Operátor výroby',
            quality_employee: 'Operátor kvality',
            handyman: 'Udržbár'
        },

        legends: {
            assigned: 'Priradení',
            online: 'Online',
            offline: 'Offline',
        },

        units: {
            day: 'deň | dní',
            currency_per_hour: '€/h',
            currency: '€',
            percentage: '%',
            sale_price_percentage: '% z predajnej ceny',
            currency_per_employee: '€/zam.',
            percentage_per_year: '€/rok',
            piece: 'ks',
            piece_per_375_cycles: 'ks/375 cyklov',
            piece_per_8_hours: 'ks/8 hod.',
            model: 'model | modelov',
            ton: 't',
            minute: 'min.',
            round: 'kolo | kôl',
            piece_per_hour: 'ks/h',
            second: 'sekúnda | sekúnd',
            hour: 'hod.',
            currency_per_car: '€/auto',
            employee: 'zam.',
            operation: 'operácia | operácií'
        },

        maintenances: {
            robots: 'Roboty',
            conveyors: 'Dopravné pásy',
            elevators: 'Výťahy',
            average_failures: 'Priemerný počet závažných porúch',
            average_less_severe_failures: 'Priemerný počet menej závažných porúch',
            average_non_severe_failures: 'Priemerný počet nezávažných porúch'
        },
        qualities: {
            average_severe_mismatch_production: 'Priemerná závažná nezhoda výroby',
            average_less_severe_mismatch_production: 'Priemerná menej závažná nezhoda výroby',
        },

        shifts: {
            morning: 'Ranná',
            afternoon: 'Poobedná',
            night: 'Nočná'
        },

        statistics: {
            met_demand_rate: 'Miera naplnenia dopytu',
            total_lost_profit: 'Celkový ušlý zisk',
            total_storage_cost: 'Celkové náklady za skladovanie',
            production_efficiency: 'Efektívnosť výroby',
            idle_time: 'Prestoj výroby',
            produced_cars: 'Vyrobené autá',
            employees_to_produced_cars: 'Počet zamestnancov k vyrobeným autám',
            average_cost_per_car: 'Priemerné náklady na jedno auto',
            met_production_rate: 'Miera naplnenia výroby',
            profit_per_employee: 'Zisk na jedného zamestnanca',
        },

        errors: {
            forbidden: 'Nemáte prístup ku zvolenej hre.'
        },

        errorMessages: {
            login: {
                invalid_grant: 'Nebol vytvorený autorizačný klient. Kontaktujte administrátora.',
                unknown: 'Počas prihlasovania sa vyskytla neznáma chyba. Skúste sa prihlásiť neskôr.'
            },
            register: {
                unknown: 'Počas registrácie sa vyskytla neznáma chyba. Skúste sa zaregistrovať neskôr.'
            },
            purchase_division: {
                incomplete_product_values: "Niektorý z Vami definovaných produktov nemá zadané všetky hodnoty, ktoré sa ho týkajú."
            }
        },

        toastErrors: {
            unknown_error: "Neznáma chyba",
            game_results_fetch_error: "Nepodarilo sa načítať výsledky hry {gameId}!",
            games_fetch_error: "Nepodarilo sa načítať zoznam hier!",
            game: {
                game_finished: "Hra, do ktorej sa pokúšate vstúpiť už bola ukončená!",
                game_canceled: "Hra, do ktorej sa pokúšate vstúpiť bola zrušená!",
                evaluation: {
                    title: 'Neúspešné vyhodnotenie',
                    message: 'Počas vyhodnotenia kola nastala chyba!'
                }
            }
        }
    }
}

export default messages;
